import { render, staticRenderFns } from "./OverlayContentList.vue?vue&type=template&id=2b53afee"
import script from "./OverlayContentList.vue?vue&type=script&lang=ts"
export * from "./OverlayContentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports